import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Row, Col, Label } from 'react-bootstrap';
import axios from 'axios';
import FormInput from 'components/forms/FormInput';

/**
 * Component to edit Client's Invoice payment threshold:
 * the minimum order value to enable invoice payment option.
 *
 * @param {*} props Object with the entity and changeEntity
 * @returns jsx
 */
function InvoicePaymentThreshold(props) {
  const { entity, disabled, isThresholdHasEffect } = props;

  const username = entity.getUsername();
  const currentSetting = entity.getInvoicePaymentThreshold();

  const {
    setting: storedSetting,
    is_inherited: storedIsInherited,
    inherited_from_name: storedInheritedFromName,
  } = entity.getEffectiveInvoicePaymentThreshold();

  // when was just switched to inherited, and no inherited value, need to make extra API request
  const needLookup = false && !currentSetting && storedIsInherited === false;

  const [isPending, setIsPending] = useState(needLookup);
  const [inheritedFrom, setInheritedFrom] = useState(storedInheritedFromName);
  const [inheritedSetting, setInheritedSetting] = useState(storedSetting);

  const updateEntity = (propertyName, value) => {
    const { entity, changeEntity } = props;
    const newEntity = { ...entity.updateValue(propertyName, value) };
    changeEntity(newEntity);
  };

  useEffect(() => {
    if (!needLookup) return;

    axios
      .get(`/api/clients/${username}/inheritedinvoicepaymentthreshold.json`)
      .then(response => {
        const { data } = response;
        setInheritedFrom(data.inherited_from_name);
        setInheritedSetting(data.setting);
        setIsPending(false);
      })
      .catch(console.error);
  }, [needLookup, username]);

  const { messages } = useIntl();
  const {
    title,
    no_effect: noEffect,
    placeholder,
    loading,
    info_text: infoText,
    effective_threshold: effectiveThreshold,
    not_defined: notDefined,
  } = messages.invoice_payment_threshold;
  let label = title;
  if (!isThresholdHasEffect) {
    label += ` (${noEffect})`;
  }

  return (
    <div className="form-group-attached">
      <FormInput
        infoText={infoText}
        placeholder={placeholder}
        min={0}
        prefixAddon="&euro;"
        type="number"
        label={label}
        name="invoicePaymentThreshold"
        value={currentSetting}
        meta={entity.getInvoicePaymentThresholdMetaInformation()}
        validation={entity.getInvoicePaymentThresholdValidationResult()}
        onChange={updateEntity}
        disabled={disabled || !isThresholdHasEffect}
      />
      {!currentSetting && (
        <div className="form-group form-group-default form-autocomplete">
          {isPending ? (
            <>
              <i class="fa circle-o-notch fa-spin text-warning" />
              {loading}
            </>
          ) : (
            <>
              {effectiveThreshold} <Label>{inheritedSetting ?? notDefined}</Label> via &quot;
              {inheritedFrom}
              &quot;
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default InvoicePaymentThreshold;
